// ABOUTME: React Query hook for personas data
// ABOUTME: Manages caching and state for persona definitions and metrics

import { useQuery } from '@tanstack/react-query';
import { personasApi } from '@/api/personas';

export const usePersonas = () => {
  return useQuery({
    queryKey: ['personas'],
    queryFn: () => personasApi.getPersonas(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
